<template>
	<div class="page">
		<Tip :title="title" />
		<div class="from_div">
			<el-form label-position="left" :rules="rules" label-width="100px">
				<el-form-item label="结算方：" style="margin-bottom: 0px;">
					<div class="row">
						<span class="span">{{detail.supplier_company}}</span>
						<span class="span" style="margin-left: 100px;">结算单号：{{detail.settlement_no}}</span>
					</div>
				</el-form-item>
				<el-table class="table_div" :data="detail.sku_list" :header-cell-style="tabStyle">
					<el-table-column label="编号" type="index" width="80">
					</el-table-column>
					<el-table-column label="商品">
						<template slot-scope="scope">
							<div class="col">
								<span>名称：{{scope.row.good_name}}</span>
								<span>规格：{{scope.row.spec_data_str}}</span>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="未结算量" align="center">
						<template slot-scope="scope">
							<span>{{scope.row.settlement_undo}}</span>
						</template>
					</el-table-column>
					<el-table-column label="本次结算" align="center">
						<template slot-scope="scope">
							<el-input class="input" v-model="scope.row.quatity" @change="(currentValue)=>changerow(currentValue, scope.$index)" placeholder="1000" />
						</template>
					</el-table-column>
					<el-table-column label="单价" align="center">
						<template slot-scope="scope">
							<el-input class="input" v-model="scope.row.price" @change="(currentValue)=>changerow(currentValue, scope.$index)" placeholder="2.36" />
						</template>
					</el-table-column>
					<el-table-column label="金额" align="center">
						<template slot-scope="scope">
							<span>{{scope.row.settlement_undo_amount}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" align="center">
						<template slot-scope="scope">
							<el-button class="item_btn" size="mini" type="danger" v-if="detail.sku_list.length > 1" @click="del(scope.$index)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-form-item label="合计金额：" prop="settlement_amount">
					<div class="row">
						<span class="span">{{amount_calc}}元</span>
						<span class="span" style="margin-left: 100px;">修改结算金额为：</span>
						<el-input class="input" style="margin-right: 10px;" v-model="detail.settlement_amount" placeholder="" />
						<span class="span">元</span>
					</div>
				</el-form-item>
				<el-form-item label="收款信息：">
				</el-form-item>
                <el-form-item label="银行卡号：" prop="collection_card">
                    <el-input class="input_" style="margin-right: 10px;" v-model="detail.collection_card" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="账户名称：" prop="collection_name">
                    <el-input class="input_" style="margin-right: 10px;" v-model="detail.collection_name" placeholder="请输入" />
                </el-form-item>
                <el-form-item label="开户银行：" prop="collection_bank">
                    <el-input class="input_" style="margin-right: 10px;" v-model="detail.collection_bank" placeholder="请输入" />
                </el-form-item>
			</el-form>
		</div>
		<div class="foot_div">
			<el-button @click="close(0)">返回</el-button>
			<!-- <el-button type="warning" @click="close(1)">制付款单</el-button> -->
			<el-button type="primary" @click="close(1)">确认</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
    import {
		supplier,
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip
		},
        props: {
			type: {
				type: Number
			}
		},
		data() {
			return {
				title: '批量结算',
				detail: {},
                form: {
                    sku_ids: '',
                },
                amount_calc: 0,
                rules: {
                    settlement_amount: [
                        { required: true, message: '请输入结算金额', trigger: 'blur' },
                    ],
                    collection_card: [
                        { required: true, message: '请输入银行卡号', trigger: 'blur' },
                        { max: 50, message: '长度最大50个字符', trigger: 'blur' }
                    ],
                    collection_name: [
                        { required: true, message: '请输入账户名称', trigger: 'blur' },
                        { max: 50, message: '长度最大50个字符', trigger: 'blur' }
                    ],
                    collection_bank: [
                        { required: true, message: '请输入开户银行', trigger: 'blur' },
                        { max: 50, message: '长度最大50个字符', trigger: 'blur' }
                    ],
                }
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
		mounted() {
            if(this.type){
                this.form.settlement_id = this.type;
            }
            this.getSupplierSale();
        },
		methods: {
            getSupplierSale(page){
                this.loading = true;
                this.form.page = page || this.form.page;
                supplier(this.form, 1).then(res => {
                    this.loading = false;
					if (res.code == 0) {
                        res.data.sku_list.forEach(ele => {
                            ele.settlement_undo_amount = ele.amount;
                            this.amount_calc = (this.amount_calc + ele.quatity * ele.price).toFixed(2);
                        });
						this.detail = res.data
					}else{
                        return this.$message.error(res.msg);
                    }
				}).catch(err => {})
            },
            del(index){
                this.detail.sku_list.splice(index, 1);
                this.calcAmount();
            },
            changerow(value, index){
                this.detail.sku_list[index].settlement_undo_amount = (this.detail.sku_list[index].quatity * this.detail.sku_list[index].price).toFixed(2);
                this.calcAmount();
            },
            calcAmount(){
                this.amount_calc = 0;
                this.detail.sku_list.forEach(ele => {
                    this.detail.settlement_amount = this.amount_calc = (this.amount_calc + ele.quatity * ele.price).toFixed(2);
                });
            },
			close(index) {
                if(index == 1){
                    this.loading = true;
                    supplier(this.detail, 5).then(res => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.$message.success(res.msg);
                            this.$emit('close',index)
                        }else{
                            return this.$message.error(res.msg);
                        }
                    }).catch(err => {})
                }else{
                    this.$emit('close',index)
                }
			}
		}
	}
</script>

<style scoped>
	.page {
		width: calc(100% - 40px);
		background: #fff;
		position: relative;
	}

	.row {
		display: flex;
		flex-direction: row;
	}

	.col {
		display: flex;
		flex-direction: column;
	}
	
	.input {
		width: 88px;
	}
	
	.input_{
		width: 200px;
		margin: 0 0 20px 10px;
	}
	
	.from_div {
		padding-top: 20px;
		width: 100%;
		overflow: scroll;
		height: 605px;
		min-height: 100%;
		padding-bottom: 60px;
	}
	
	.table_div {
		width: 100%;
		margin: 10px 0;
	}
	

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}

	.span {
		font-size: 14px;
		color: #767676;
	}
</style>